import { useTranslation } from "react-i18next";
import { HiArrowRight, HiPlus } from "react-icons/hi2";
import { useNavigate } from "react-router-dom";

import Button from "@/components/atoms/Button";
import FeaturedText from "@/components/molecules/FeaturedText";

const EmptyListDetail = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <FeaturedText
      heading={t("static.emptyList.title")}
      body={t("static.emptyList.text")}
      size={"lg"}
      featuredIcon={{
        icon: HiPlus,
        color: "primary",
        size: "xl",
      }}
      children={
        <div className={"mt-2"}>
          <Button
            label={t("static.emptyList.button")}
            onClick={() => navigate("/")}
            trailingIcon={<HiArrowRight className={"size-5"} />}
          />
        </div>
      }
    />
  );
};

export default EmptyListDetail;
